import React, { useState, useRef, useEffect } from 'react';
import ImageModal from './ImageModal';

const ImagePopupWrapper = ({ children, className = '' }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [modalAlt, setModalAlt] = useState('');
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleImageClick = (e) => {
      // Prevent if modal is already open
      if (modalOpen) return;
      
      if (e.target.tagName === 'IMG') {
        // Don't open popup for thumbnail images or other images that should be excluded
        if (e.target.closest('.project-thumbnail') || 
            e.target.closest('.carousel-slide') ||
            e.target.classList.contains('no-popup')) {
          return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        setModalImage(e.target.src);
        setModalAlt(e.target.alt || 'Full size image');
        setModalOpen(true);
      }
    };

    const wrapper = wrapperRef.current;
    if (wrapper) {
      wrapper.addEventListener('click', handleImageClick, true); // Use capture phase
    }

    return () => {
      if (wrapper) {
        wrapper.removeEventListener('click', handleImageClick, true);
      }
    };
  }, [modalOpen]); // Include modalOpen in dependencies

  const closeModal = () => {
    setModalOpen(false);
    // Delay clearing image src to allow for closing animation
    setTimeout(() => {
      setModalImage('');
      setModalAlt('');
    }, 100);
  };

  return (
    <>
      <div ref={wrapperRef} className={className}>
        {children}
      </div>
      
      <ImageModal
        isOpen={modalOpen}
        imageSrc={modalImage}
        imageAlt={modalAlt}
        onClose={closeModal}
      />
    </>
  );
};

export default ImagePopupWrapper; 